<div class="loading-skeleton-wrapper">
  <div class="loading-skeleton-container">
    <div class="skeleton-body">
      <!-- Logo Circles Section -->
      <div class="skeleton-logos">
        <div class="skeleton-circle logo-left shimmer"></div>
        <div class="skeleton-link-connector shimmer"></div>
        <div class="skeleton-circle logo-right shimmer"></div>
      </div>

      <!-- Greeting Line -->
      <div class="skeleton-greeting">
        <div class="skeleton-line greeting-line shimmer"></div>
      </div>

      <!-- Main Message Section -->
      <div class="skeleton-main-message">
        <div class="skeleton-line title-line shimmer"></div>
        <div class="skeleton-line description-line shimmer"></div>
        <div class="skeleton-line description-line-short shimmer"></div>
      </div>

      <!-- Info Cards -->
      <div class="skeleton-cards">
        <div class="skeleton-card card-1 shimmer">
          <div class="skeleton-card-icon"></div>
          <div class="skeleton-card-content">
            <div class="skeleton-card-title"></div>
            <div class="skeleton-card-text"></div>
          </div>
        </div>

        <div class="skeleton-card card-2 shimmer">
          <div class="skeleton-card-icon"></div>
          <div class="skeleton-card-content">
            <div class="skeleton-card-title"></div>
            <div class="skeleton-card-text"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="skeleton-footer">
      <div class="skeleton-button shimmer"></div>
    </div>
  </div>
</div>

